import React, { useState, useEffect } from "react";
import {
  FormControl,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
} from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";

const SORT_OPTIONS = [
  { key: "name-asc", label: "Name (A → Z)", sort: "name", sortOrder: "asc" },
  { key: "name-desc", label: "Name (Z → A)", sort: "name", sortOrder: "desc" },
  { key: "price-desc", label: "Price (high → low)", sort: "price", sortOrder: "desc" },
  { key: "price-asc", label: "Price (low → high)", sort: "price", sortOrder: "asc" },
  { key: "stock-desc", label: "Stock (high → low)", sort: "stock", sortOrder: "desc" },
  { key: "stock-asc", label: "Stock (low → high)", sort: "stock", sortOrder: "asc" },
];

const PAGE_SIZES = ["15", "30", "60", "90"];

export const ShopSort = (props) => {
  const [search, setSearch] = useState(props.search || "");
  const [pageSize, setPageSize] = useState("30");
  const [sortKey, setSortKey] = useState("name-asc");

  // Debounced search
  useEffect(() => {
    const t = setTimeout(() => {
      if (props.onSearchChange) props.onSearchChange(search);
    }, 400);
    return () => clearTimeout(t);
  }, [search]);

  const handlePageSizeChange = (e) => {
    const v = e.target.value;
    setPageSize(v);
    if (props.onPageSizeChange) props.onPageSizeChange(v);
  };

  const handleSortChange = (e) => {
    const v = e.target.value;
    setSortKey(v);
    const opt = SORT_OPTIONS.find((o) => o.key === v);
    if (opt && props.onSortChange) {
      props.onSortChange({ sort: opt.sort, sortOrder: opt.sortOrder });
    }
  };

  return (
    <Stack
      direction={{ xs: "column", sm: "row" }}
      spacing={1.5}
      alignItems={{ xs: "stretch", sm: "center" }}
      sx={{ flex: 1, flexWrap: "wrap" }}
      useFlexGap
    >
      <TextField
        type="search"
        size="small"
        placeholder="Search products…"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchOutlinedIcon fontSize="small" sx={{ color: "text.secondary" }} />
            </InputAdornment>
          ),
        }}
        sx={{ flex: 1, minWidth: { md: 240 } }}
      />

      <FormControl size="small" sx={{ minWidth: 180 }}>
        <InputLabel id="sort-label">Sort by</InputLabel>
        <Select
          labelId="sort-label"
          label="Sort by"
          value={sortKey}
          onChange={handleSortChange}
        >
          {SORT_OPTIONS.map((o) => (
            <MenuItem key={o.key} value={o.key}>
              {o.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      <FormControl size="small" sx={{ minWidth: 120 }}>
        <InputLabel id="pagesize-label">Per page</InputLabel>
        <Select
          labelId="pagesize-label"
          label="Per page"
          value={pageSize}
          onChange={handlePageSizeChange}
        >
          {PAGE_SIZES.map((p) => (
            <MenuItem key={p} value={p}>
              {p}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Stack>
  );
};
